/*======================================================================================================================
  * Bluebell: src/main.ts
  * Last Edited: 10/12/2024
  * Copyright 2016-2024 Bramble CFD LTD
  * The contents of this file are NOT for redistribution
  * See AUTHORS for list of developers on this project
 =====================================================================================================================*/
import { appConfig } from '@app/app.config';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '@app/app.component';

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
